import React, { Component } from "react";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { get } from "lodash";
import { connect } from "react-redux";
import { shortDate, shortDateYY } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import {
  INVENTORIES,
  FLAG_TYPES,
  MODIFIED
} from "MODULES/inventories/constants";
import Controls from "MODULES/inventories/components/Controls";
import InventoryListingOverrideCell from "MODULES/shared/components/InventoryListingOverrideCell";
import InventoryQuantityCell from "MODULES/shared/components/InventoryQuantityCell";
import InventoryStatusCell from "MODULES/shared/components/InventoryStatusCell";
import InventoryTagDateCell from "MODULES/shared/components/InventoryTagDateCell";
import Warnings from "MODULES/inventories/components/Detail/Warnings";
import classNames from "classnames";
import {
  SearchPropTypes,
  LocationFlag,
  LinkedTableRow
} from "MODULES/shared/components";
import ModifiedFlag, {
  columnStyle
} from "MODULES/parts/components/ModifiedFlag";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import { inventoryTaggedBy } from "MODULES/inventories/helpers";
import { displaySrp } from "../../helpers";

export class Table extends Component {
  renderInventoryRow = (r, i, pushHistory, renderDummyValues) => {
    const activeFlags = Object.keys(FLAG_TYPES).filter(t => r[t]);
    const hasModifiedFlag = activeFlags.includes(MODIFIED);
    const onlyModifiedFlag = activeFlags.length === 1 && hasModifiedFlag;

    const flagTypes = activeFlags.map(t => FLAG_TYPES[t].label).join(", ");

    return (
      <LinkedTableRow
        to={`/inventories/${r.uuid}`}
        key={renderDummyValues ? `d-${i}` : i}
        className={classNames({ "text-muted": renderDummyValues })}
      >
        <td>{renderDummyValues ? `${i + 1}D` : i + 1}</td>
        <InventoryStatusCell inventory={r}>
          <InventoryListingOverrideCell
            inventory={r}
            renderDummyValues={renderDummyValues}
          />
        </InventoryStatusCell>
        <td>{!renderDummyValues && shortDate(r.date_received)}</td>
        <td>
          {!renderDummyValues &&
            getFirstNameLastInitial(get(r, "buyer.full_name"))}
        </td>
        <td>
          {!renderDummyValues &&
            getFirstNameLastInitial(get(r, "co_buyer.full_name"))}
        </td>
        <td>
          {!renderDummyValues &&
            getFirstNameLastInitial(get(r, "third_buyer.full_name"))}
        </td>
        <td>{!renderDummyValues && r.serial_number}</td>
        <MultiLocationFeature>
          <td>
            {!renderDummyValues && <LocationFlag location={r.store_owner_id} />}
          </td>
          <td>
            {!renderDummyValues && (
              <LocationFlag location={r.store_location_id} />
            )}
          </td>
        </MultiLocationFeature>
        <td className="text-center">
          {flagTypes &&
            !onlyModifiedFlag && (
              <i
                title={flagTypes}
                className="fa fa-fw fa-flag"
                style={{ color: "red" }}
              />
            )}
        </td>
        <td>
          {!renderDummyValues && r.location === "Shipped To Customer"
            ? "Shipped To Cust."
            : r.location}
        </td>
        <td>{!renderDummyValues && <Warnings inventory={r} />}</td>
        <td>{!renderDummyValues && truncate(r.traced_to, 24)}</td>
        <InventoryTagDateCell
          inventory={r}
          renderDummyValues={renderDummyValues}
        />
        <td>{!renderDummyValues && inventoryTaggedBy(r)}</td>
        <td>
          {!renderDummyValues &&
            getFirstNameLastInitial(get(r, "reserve_for_seller.full_name"))}
        </td>
        <td>
          {!renderDummyValues &&
            r.reserved_for_sale_on &&
            shortDateYY(r.reserved_for_sale_on)}
        </td>
        <td>
          {!renderDummyValues &&
            getFirstNameLastInitial(get(r, "reserved_by.full_name"))}
        </td>
        <td style={columnStyle.flagColumn}>
          {hasModifiedFlag && <ModifiedFlag />}
        </td>
        <td className="text-center" style={columnStyle.conditionColumn}>
          {renderDummyValues
            ? get(INVENTORIES, `condition.${r.dummy.condition}.abbrev`)
            : get(INVENTORIES, `condition.${r.condition}.abbrev`)}
        </td>
        <td>{r.release_type}</td>
        <InventoryQuantityCell
          inventory={r}
          renderDummyValues={renderDummyValues}
        />
        <td className="text-right">
          {!renderDummyValues && dollars(r.cost_per_unit)}
        </td>
        <td className="text-center">{displaySrp(renderDummyValues, r)}</td>
        <NoteTooltipTableCell
          note={renderDummyValues ? r.dummy.note : r.important_note}
          color={r.important_note && "#f44336"}
        />
        <td>{!renderDummyValues && <Controls inventory={r} />}</td>
      </LinkedTableRow>
    );
  };

  renderRow = (inventory, i, pushHistory) => {
    if (inventory.dummy) {
      return [
        this.renderInventoryRow(inventory, i, pushHistory),
        this.renderInventoryRow(inventory, i, pushHistory, true)
      ];
    }
    return this.renderInventoryRow(inventory, i, pushHistory);
  };

  render() {
    const { pushHistory, results } = this.props;

    return (
      <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
        <table className="table table-striped table-hover table-numbered">
          <thead>
            <tr>
              <th />
              <th />
              <th>Date Received</th>
              <th>Buyer</th>
              <th>Co-Buyer</th>
              <th>Third Buyer</th>
              <th>Serial #</th>
              <MultiLocationFeature>
                <th>Store Owner</th>
                <th>Store Loc</th>
              </MultiLocationFeature>
              <th>Flag</th>
              <th>LOC</th>
              <th>Status</th>
              <th>Trace To</th>
              <th>Tag Date</th>
              <th>Tagged By</th>
              <th>Res. For</th>
              <th>Res. Date</th>
              <th>Res. By</th>
              <th />
              <th className="text-center">CD</th>
              <th>Release</th>
              <th className="text-right">QTY</th>
              <th className="text-right">Cost</th>
              <th className="text-center">SRP</th>
              <th className="text-center" />
              <th className="text-center" />
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => this.renderRow(r, i, pushHistory))}
          </tbody>
        </table>
      </div>
    );
  }
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Inventories/Table.jsx